import styled from 'styled-components';

const Actions = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;

  > *:not(:last-child) {
    margin-right: 8px;
  }

  &:hover {
    svg {
      opacity: 1;
    }
  }
`;

export default Actions;
